module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_j_normal.bfd5b021.png";